import { PROCESSING_STATUSES, COMMUNITY_PROPOSED, KEEPCON_PROPOSED } from './moderation.js';
import {
    SERVICE_V2, SERVICE_LIVECOMMENT, SERVICE_LIVESTORIES, SERVICE_LIVECHAT,
} from '@/constants/service';
import { HISTORY_CONTENT_ACTIONS } from '@/constants/content.js';

export const IS_OPERATOR = 'equals';
export const NOT_OPERATOR = 'not_equals';
export const RANGE_OPERATOR = 'range';
export const RELATIVE_TIME_OPERATOR = 'relative_time';
export const FROM_OPERATOR = 'from';
export const TO_OPERATOR = 'to';
export const LOGICAL_OPERATORS = [ IS_OPERATOR, NOT_OPERATOR ];

export const CLIENT_UUID_FILTER = 'client_uuid';
export const SITE_UUID_FILTER = 'site_uuid';
export const SECTION_UUID_FILTER = 'section_uuid';

export const FILTERS = {
    actions: {
        field: 'actions',
        values: [
            'approved',
            'disable_by_flag',
            'editor_pick',
            'editor_unpick',
            'rejected',
            'reviewed',
            'spam',
            'unflag',
            // 'edited',
            // 'flagged',
            'unspam',
            'pinned',
            'unpinned',
            HISTORY_CONTENT_ACTIONS.TOP_COMMENTS_EXCLUDED,
            HISTORY_CONTENT_ACTIONS.TOP_COMMENTS_REINCLUDED,
        ],
    },
    url: {
        field: 'url',
    },
    content_type: {
        field: 'content_type',
        values: [
            'image',
            // 'review',
            'text',
            // 'url',
            // 'chat',
            // 'display_name',
            // 'avatar',
            // 'live_post',
        ],
    },
    automod_outcomes: {
        field: 'automod_outcomes',
        values: [
            'keepcon_approved',
            'keepcon_rejected',
            'akismet_rejected',
            'keepcon_unknown',
            'keepcon_none',
        ],
    },
    content_id: {
        field: 'content_id',
    },
    content_container_uuid: {
        field: 'content_container_uuid',
    },
    content_source: {
        field: 'content_source',
        values: [
            'comment',
            'chat',
            'review',
            'livestory_comment',
            'question',
        ],
    },
    content_attributes: {
        field: 'content_attributes',
        values: [
            'top_content',
            'featured_content',
            'is_pinned',
            'is_reply',
            'is_question',
            'is_answer',
        ],
    },
    processing_status: {
        field: 'processing_status',
        values: Object.values(PROCESSING_STATUSES),
    },
    content: {
        field: 'content',
    },
    // Date range is a special case. We want to have an alias for the date_created field
    date_range: {
        field: 'last_action_time',
        title: 'date_range',
    },
    date_created: {
        field: 'date_created',
        disabled: true,
    },

    // Relative Time filter is an alias for date_range filter where the default field is last_action,
    // the default value is 24 hours and the operator is "relative_time"
    // options represents how many hours should be looked back in relative time.
    relative_time: {
        field: 'last_action_time',
        operator: 'relative_time',
        options: [ 1, 3, 6, 12, 24, 48, 168 ],
        default_option: 24,

        disabled: true,
    },

    ip: {
        field: 'ip',
    },
    last_action: {
        field: 'last_action_time',
        disabled: true,
    },
    moderator_uuid: {
        field: 'moderator_uuid',
        disabled: true,
    },
    moderator_actions: {
        field: 'moderator_actions',
        values: [
            'approved',
            'editor_pick',
            'editor_unpick',
            'rejected',
            'reviewed',
            'spam',
            'unflag',
            // 'disable_by_flag',
            // 'edited',
            'unspam',
            'pinned',
            'unpinned',
            HISTORY_CONTENT_ACTIONS.TOP_COMMENTS_EXCLUDED,
            HISTORY_CONTENT_ACTIONS.TOP_COMMENTS_REINCLUDED,
        ],
    },
    report_reason: {
        field: 'report_reason',
        values: [
            'disagree',
            'harassment',
            'spam',
            'inappropriate',
            'threatening',
            'impersonation',
            'private',
            'custom_1',
            'custom_2',
        ],
    },
    client_uuid: {
        field: 'client_uuid',
    },
    site_uuid: {
        field: 'site_uuid',
        disabled: true,
    },
    section_uuid: {
        field: 'section_uuid',
        disabled: true,
    },
    section_name: {
        field: 'section_name',
        disabled: true,
    },
    tag_names: {
        field: 'tag_names',
        values: [],
    },
    tag_source_statuses: {
        field: 'tag_source_statuses',
        values: [
            KEEPCON_PROPOSED,
            COMMUNITY_PROPOSED,
        ],
    },
    third_party_id: {
        field: 'third_party_id',
        disabled: true,
    },
    user_email: {
        field: 'user_email',
        disabled: true,
    },
    actor_uuid: {
        field: 'actor_uuid',
    },
    user_name: {
        field: 'user_name',
        disabled: true,
    },
    user_tags: {
        field: 'user_tags',
        values: [
            'admin',
            'mod',
            'site_user',
            'trusted',
            'subscriber',
        ],
        disabled: true,
    },
    service: {
        field: 'service',
        values: [
            SERVICE_V2,
            SERVICE_LIVECOMMENT,
            SERVICE_LIVESTORIES,
            SERVICE_LIVECHAT,
        ],
        disabled: true,
    },
};
